import InputMaskContainer from "../../../../../Components/Forms&Table/Forms/FormControls/InputMask/InputMarkContainer";

const InputMark = () => {
  return <InputMaskContainer />;
};

export default InputMark;
